import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { CardTitle } from '@swf/sports/components';

import Competitions from './templates/Competitions/Competitions';
import Events from './templates/Events/Events';
import Meetings from './templates/Meetings/Meetings';

const QuickSwitcher = ({ title }: { title: React.ReactNode }) => {
  const quickSwitcherData = useSelector(select.quickSwitcher.data);

  if (quickSwitcherData) {
    // eslint-disable-next-line no-underscore-dangle
    switch (quickSwitcherData._type) {
      case 'COMPETITIONS':
        return <Competitions title={title} quickSwitcherData={quickSwitcherData} />;
      case 'EVENTS':
        return <Events title={title} quickSwitcherData={quickSwitcherData} />;
      case 'MEETINGS':
        return <Meetings title={title} quickSwitcherData={quickSwitcherData} />;
    }
  }

  return <CardTitle>{title}</CardTitle>;
};

export default QuickSwitcher;
